import React, { FC, useContext } from "react";
import { GridLegacy as Grid } from "@mui/material";

import { IPreferences } from "../../logic/api";

import EditableField, {
  EditableFieldTypes,
} from "../../components/editable/EditableField/EditableField";
import EditableGroup, {
  EditableGroupType,
} from "../../components/editable/EditableGroup/EditableGroup";
import NotchedCard from "../../components/cards/NotchedCard/NotchedCard";

import { SessionContext } from "../../utility/useSession";
import styles from "./styles";
import { useTranslation } from "react-i18next";

interface ICustomerLookupSettingsProps {
  onSave: (data: Partial<IPreferences>) => Promise<boolean>;
}

export const CustomerLookupSettings: FC<ICustomerLookupSettingsProps> = ({ onSave }) => {
  const session = useContext(SessionContext);
  const { t } = useTranslation();

  if (!session.current.site) {
    return null;
  }



  return (
    <Grid item xs={12}>
      <NotchedCard label={t("settings.customerLookup")} style={styles.card}>
        <EditableGroup<IPreferences>
          id="customerLookupSettings"
          editType={EditableGroupType.switchableEditing}
          data={session.current.site.preferences}
          onDataChanged={(data) => onSave({
            customer_look_up_enabled: data.customer_look_up_enabled,
          })}
          testId="customer-lookup-settings"
        >
          <Grid container>
            <Grid item sm={2} xs={6}>
              <EditableField<IPreferences, boolean>
                useFullWidthWhenEditing={false}
                inputType={EditableFieldTypes.switch}
                label={t("reports.enabled")}
                onProvide={(data) =>
                  Boolean(data.customer_look_up_enabled)
                }
                onChange={(data, value) =>
                  data.customer_look_up_enabled = Boolean(value)
                }
                testId="settings-customer-lookup-enabled-switch"
              />
            </Grid>
          </Grid>
        </EditableGroup>
      </NotchedCard>
    </Grid>
  );
};
